import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { ApplicationUser } from "../../src/entities/ApplicationUser";
import { routes } from "../routes";
import { AuthenticatedUserContext } from "../utilities/useAuthenticatedUser";

interface PrivateRouteProps extends RouteProps {
    user: ApplicationUser | null;
}

export const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({ component, ...rest }) => {

    const renderComponent = (Component: any) => (props: RouteProps) => {

        return <Component {...props} />;
    };
    const user = rest.user;

    if (!user) {
        return (
            <Route
                {...rest}
                render={(routeProps) => {

                    // allow Caleb to direct new user to upgrade immediately.
                    const redirectBase = routeProps.location ? routeProps.location.search.indexOf('newUser') > -1 ? routes.public.reqisterPage : routes.public.signInPage : routes.public.signInPage;
                    const redirectWithQuery = `${redirectBase}?redirect=${encodeURI(routeProps.location.pathname + routeProps.location.search)}`
                    return <Redirect to={redirectWithQuery} />;
                }}
            />
        );
    }
    else if (rest.location && rest.location.search.indexOf('upgrade=standard') > -1) {     
        window.location.assign("https://www.sermonmaker.net/activate");
        return null;
    }
    else if (component) {
        return <AuthenticatedUserContext.Provider value={user}><Route {...rest} render={renderComponent(component)} /></AuthenticatedUserContext.Provider> ;
    }
    else if (rest.render) {
        return <AuthenticatedUserContext.Provider value={user}><Route {...rest} render={rest.render} /></AuthenticatedUserContext.Provider>;
    }
    else {
        return null;
    }
};